export const naturalNotes = [
   { name: 'C', note: -21 },
   { name: 'D', note: -19 },
   { name: 'E', note: -17 },
   { name: 'F', note: -16 },
   { name: 'G', note: -14 },
   { name: 'A', note: -12 },
   { name: 'B', note: -10 },
];

export const simpleSharps = [
   { name: 'C♯', note: -20 },
   { name: 'D♯', note: -18 },
   { name: 'F♯', note: -15 },
   { name: 'G♯', note: -13 },
   { name: 'A♯', note: -11 },
];

export const simpleFlats = [
   { name: 'D♭', note: -20 },
   { name: 'E♭', note: -18 },
   { name: 'G♭', note: -15 },
   { name: 'A♭', note: -13 },
   { name: 'B♭', note: -11 },
];
